var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportEmail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80.9,
    viewBox: "0 0 80 80.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12298",
    "data-name": "Group 12298",
    transform: "translate(-233.879 -323)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18136",
    "data-name": "Rectangle 18136",
    width: 80,
    height: 80,
    transform: "translate(233.879 323.5)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\xCDCONE",
    transform: "translate(241.88 323.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12691",
    "data-name": "Path 12691",
    d: "M606.073,168.508h27.012a2.2,2.2,0,0,0,0-4.284H606.073a2.2,2.2,0,0,0,0,4.284Z",
    transform: "translate(-591.811 -135.088)",
    fill: "#2f64f5",
    stroke: "#2f64f5",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12692",
    "data-name": "Path 12692",
    d: "M606.466,172.32H632.9a2.142,2.142,0,0,0,0-4.284H606.466a2.142,2.142,0,0,0,0,4.284Z",
    transform: "translate(-591.925 -129.286)",
    fill: "#2f64f5",
    stroke: "#2f64f5",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12693",
    "data-name": "Path 12693",
    d: "M624.325,223.173H606.654a2.13,2.13,0,0,1-2.127-2.133V175.9H619.47a2.132,2.132,0,0,0,2.126-2.133V158.617h27.768a2.269,2.269,0,0,1,2.278,2.133v38.577a2.126,2.126,0,1,0,4.253,0V160.759a6.536,6.536,0,0,0-6.522-6.426h-29.9a2.136,2.136,0,0,0-1.519.634l-17.1,17.281a2.151,2.151,0,0,0-.607,1.523v47.259a6.425,6.425,0,0,0,6.407,6.426h17.653a2.142,2.142,0,0,0,.018-4.284Zm-6.99-61.494v9.936h-9.824Z",
    transform: "translate(-600.247 -154.333)",
    fill: "#2f64f5",
    stroke: "#2f64f5",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12755",
    "data-name": "Path 12755",
    d: "M31.364,27.133H3.485A3.439,3.439,0,0,1,0,23.741V3.244A3.444,3.444,0,0,1,3.485,0H31.364a3.439,3.439,0,0,1,3.485,3.392v20.35A3.439,3.439,0,0,1,31.364,27.133ZM3.485,6.559V23.741H31.364V6.559L17.425,15.6ZM4.879,3.392l12.546,8.14L29.97,3.392Z",
    transform: "translate(30.45 52.867)",
    fill: "#2f64f5",
    stroke: "#2f64f5",
    strokeWidth: 0.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportEmail);
export default __webpack_public_path__ + "static/media/report-email.3f3dedd98607112e92551d6b4eef9522.svg";
export { ForwardRef as ReactComponent };